<template>
  <div class="mb-base text-center padding-10">

    {{ settings }}
    <vue-apex-charts type="radialBar" height="180" :options="chartOptions" :series="theSeries" />
    <div :style="{
      backgroundColor: settings.value.color,
      marginLeft: '30px',
      marginRight: '30px',
      color: 'white',
      padding: '5px',
      fontWeight: 'bold'
    }">
      <p>Done: {{ settings.value.counts[0] }}</p>
      <p>Pending: {{ settings.value.counts[1] }}</p>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    VueApexCharts,
  },
  props: {
    settings: Object,
    default: {},
  },
  computed: {
    theSeries() {
      return this.settings.value.val;
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 250,
          type: "radialBar",
          offsetY: -10,
          color: this.settings.value.color,
        },
        plotOptions: {
          radialBar: {
            size: 158,
            offsetY: -15,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: "65%",
            },

            dataLabels: {
              value: {
                offsetY: 30,
                color: "#99a2ac",
                fontSize: "1.5rem",
              },
            },
          },
        },
        // plotOptions: {
        //   radialBar: {
        //     startAngle: -135,
        //     endAngle: 135,
        //     color: "red",
        //     dataLabels: {
        //       name: {
        //         fontSize: "16px",
        //         color: "black",
        //         offsetY: 120,
        //       },
        //       value: {
        //         offsetY: 76,
        //         fontSize: "22px",
        //         color: "black",
        //         formatter: function (val) {
        //           return val + "%";
        //         },
        //       },
        //     },
        //   },
        // },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91],
          },
        },
        stroke: {
          dashArray: 8,
          color: this.settings.value.color,
        },
        labels: this.settings.value.label,
        colors: [this.settings.value.color],
      },
    };
  },
  created() {
    console.log("settings radial2:", this.settings);
  },
};
</script>

<style></style>
